import { useState, useEffect } from "react";
import "@/App.css";
import EnvelopeIntro from "./components/EnvelopeIntro";
import HeroSection from "./components/HeroSection";
import DetailsSection from "./components/DetailsSection";
import LocationSection from "./components/LocationSection";
import RSVPSection from "./components/RSVPSection";
import AccommodationSection from "./components/AccommodationSection";
import GiftSection from "./components/GiftSection";
import Footer from "./components/Footer";
import FloralDecorations from "./components/FloralDecorations";
import SectionDivider from "./components/SectionDivider";

function App() {
  const [isEnvelopeOpen, setIsEnvelopeOpen] = useState(false);
  const [showContent, setShowContent] = useState(false);

  const handleEnvelopeOpen = () => {
    setIsEnvelopeOpen(true);
    setTimeout(() => {
      setShowContent(true);
    }, 400);
  };

  useEffect(() => {
    // Check if user has already seen the intro
    const hasSeenIntro = sessionStorage.getItem('hasSeenIntro');
    if (hasSeenIntro) {
      setIsEnvelopeOpen(true);
      setShowContent(true);
    }
  }, []);

  useEffect(() => {
    if (showContent) {
      sessionStorage.setItem('hasSeenIntro', 'true');
    }
  }, [showContent]);

  return (
    <div className="App min-h-screen bg-[#F9F7F2]">
      {!showContent && (
        <EnvelopeIntro 
          isOpen={isEnvelopeOpen} 
          onOpen={handleEnvelopeOpen} 
        />
      )}
      
      {showContent && (
        <main className="relative overflow-hidden">
          <FloralDecorations />
          <HeroSection />
          <SectionDivider variant="flower" />
          <DetailsSection />
          <SectionDivider variant="line" />
          <LocationSection />
          <SectionDivider variant="dots" />
          <RSVPSection />
          <SectionDivider variant="flower" />
          <AccommodationSection />
          <SectionDivider variant="line" />
          <GiftSection />
          <Footer />
        </main>
      )}
    </div>
  );
}

export default App;
